// extracted by mini-css-extract-plugin
module.exports = {"content":"ExternalContent__content___SgT_P","heading":"ExternalContent__heading___3tNOc"};